import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import style from './NumberBadge.module.scss.js';

const { componentTestLabel } = getTestLabels('NumberBadge');
/**
 * [design (Figma)](https://www.figma.com/design/MUnGlxUUspXSbRkFsEXWGQ/%F0%9F%92%A0-Core-Components?node-id=4886-4440&t=IruA6WPg8EkG99wC-0)
 * | [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Badge/NumberBadge/NumberBadge.tsx)
 *
 * @param {number} amount - The number displayed by the badge (any amount greater than 99 will display as `99+`).
 * @param {('cart' | 'neutral' | 'primary')} variant - (optional) Controls the color/style of the badge. Can be one of `cart`, `neutral`,  or `primary` (defaults to `neutral`).
 */
const NumberBadge = forwardRef((props, ref) => {
    const { className, amount, variant = 'neutral', ...otherProps } = props;
    return (jsx("span", { "data-zta": componentTestLabel, ref: ref, className: classNames(className, style['z-number-badge'], {
            [style[`z-number-badge--variant-${variant}`]]: variant !== 'neutral',
        }), ...otherProps, children: jsx("span", { children: amount < 100 ? amount : '99+' }) }));
});
NumberBadge.displayName = 'NumberBadge';

export { NumberBadge };
//# sourceMappingURL=NumberBadge.js.map
